
var moment = require('moment')

export const dataDashboard = (dates,runningIndex,runningIndexMedianList,chartColor,gradientFill,range) =>{
    const topRange = parseInt(range[1] * dates.length/100)
    const lowRange = parseInt(range[0] * dates.length/100)
    dates = dates.slice(lowRange,topRange)
    runningIndex = runningIndex.slice(lowRange,topRange)
    runningIndexMedianList = runningIndexMedianList.slice(lowRange,topRange)
    
    return (
        {
            labels:dates,
            datasets: [
              {
                label: "Index raw",
                borderColor: "rgb(255,230,100)",
                pointBorderColor: "rgb(255,230,100)",
                pointBackgroundColor: "rgb(255,230,100)",
                pointHoverBackgroundColor: "rgb(255,230,100)",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 1,
                pointHoverRadius: 2,
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                fill: false,
                backgroundColor: gradientFill,
                borderWidth: 2,
                data: runningIndex,
                showLine:false,
              },
              {
                label: "Index median",
                borderColor: chartColor,
                pointBorderColor: chartColor,
                pointBackgroundColor: "#2c2c2c",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 1,
                pointHoverRadius: 7,
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                fill: true,
                backgroundColor: gradientFill,
                borderWidth: 2,
                data: runningIndexMedianList,
              },
            ]
        }
    )
}


export const optionsDashboard = (max,min,maxMedian,minMedian,focus) =>{
    
    var maxValue = max
    var minValue = 25
    
    if(focus === "Default"){
        maxValue = max
        minValue = 25
    }
    if(focus === "Raw"){
        maxValue = max
        minValue = min
    }
    if(focus === "Median"){
        maxValue = maxMedian+2
        minValue = minMedian-2
    }
    return (
        {
        layout: {
            padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0,
            },
        },
        maintainAspectRatio: false,
        tooltips: {
            backgroundColor: "#fff",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
        },
        legend: {
            position: "bottom",
            fillStyle: "#FFF",
            display: false,
        },
        scales: {
            yAxes: [
            {
                ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,
                max:parseFloat(maxValue),
                min:parseFloat(minValue),
                },
                gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent",
                },
            },
            ],
            xAxes: [
            {
                gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)",
                },
                ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                },
                type:'time',
                distribution: 'series',
                time: {
                displayFormats: {
                parser: 'YYYY/MM/DD',
                unit: 'day',
                unitStepSize: 1,
                
                quarter: 'MMM YYYY'
                }
                }
            },
            ],
        },
        plugins:{
            zoom:{
                pan:{
                    enabled:false,
                    mode:'x'
                },
                zoom:{
                    enabled:false,
                    drag:false,
                    mode:'x'
                }
            }
        }
        
        }
    )
}











///  TRAINING LOAD GRAPH

export const dataTrainingLoad = (dates,fitness,fatigue,form,chartColor,gradientFill,range,fitnessCheck,fatigueCheck,formCheck) =>{
    const topRange = parseInt(range[1] * dates.length/100)
    const lowRange = parseInt(range[0] * dates.length/100)
    dates = dates.slice(lowRange,topRange)
    
    fitness = fitness.slice(lowRange,topRange)
    fatigue = fatigue.slice(lowRange,topRange)
    form = form.slice(lowRange,topRange)
    if(fitnessCheck == false){
        fitness = []
    }
    if(fatigueCheck == false){
        fatigue = []
    }
    if(formCheck == false){
        form = []
    }
    
    return (
        {
            labels:dates,
            datasets: [
              {
                label: "fitness",
                borderColor: "1ebfe8",
                pointBorderColor: "1ebfe8",
                pointBackgroundColor: "rgba(100, 100, 255, 0.8)",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 0,
                pointHoverRadius: 3,
                pointHoverBorderWidth: 1,
                pointRadius: 0,
                fill: true,
                backgroundColor: 'rgba(100, 100, 200, 0.3)',
                borderWidth: 1,
                data: fitness,
              },
              {
                label: "Fatigue",
                borderColor: "#FCBF44",
                pointBorderColor: chartColor,
                pointBackgroundColor: "rgba(255, 255, 100, 0.9)",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 1,
                pointHoverRadius: 7,
                pointHoverBorderWidth: 2,
                pointRadius: 0,
                fill: true,
                backgroundColor: gradientFill,
                borderWidth: 1,
                data: fatigue,
              },
              {
                label: "Form",
                borderColor: "#E63950",
                pointBorderColor: chartColor,
                pointBackgroundColor: "rgba(255, 100, 100, 0.9)",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 1,
                pointHoverRadius: 7,
                pointHoverBorderWidth: 2,
                pointRadius: 0,
                fill: true,
                backgroundColor: 'rgba(255, 100, 100, 0.1)',
                borderWidth: 1,
                data: form,
              },
            ]
        }
    )
}
export const optionsTrainingLoadMax = (max) =>{
    
    return (
        {
        layout: {
            padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0,
            },
        },
        maintainAspectRatio: false,
        tooltips: {
            backgroundColor: "#fff",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
        },
        legend: {
            position: "bottom",
            fillStyle: "#FFF",
            display: false,
        },
        scales: {
            yAxes: [
            {
                ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,
                max:max,
                min:-max
                },
                gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent",
                },
            },
            ],
            xAxes: [
            {
                gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)",
                },
                ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                },
                type:'time',
                distribution: 'series',
                time: {
                displayFormats: {
                parser: 'YYYY/MM/DD',
                unit: 'day',
                unitStepSize: 1,
                
                quarter: 'MMM YYYY'
                }
                }
            },
            ],
        },
        plugins:{
            zoom:{
                pan:{
                    enabled:false,
                    mode:'x'
                },
                zoom:{
                    enabled:false,
                    drag:false,
                    mode:'x'
                }
            }
        }
        
        }
    )
}
export const dataTrainingLoadProjection = (dates,fitness,fatigue,form,chartColor,gradientFill,range,pointZero) =>{
    const topRange = parseInt(range[1] * dates.length/100)
    const lowRange = parseInt(range[0] * dates.length/100)
    dates = dates.slice(lowRange,topRange)

    var pointZeroIndex = 0

    for (var i=0;i<dates.length;i++){
        if (moment(dates[i]).isAfter(moment(pointZero))){
            pointZeroIndex = i-1
            break
        }

        
    }
    fitness = fitness.slice(lowRange,topRange)
    fatigue = fatigue.slice(lowRange,topRange)
    form = form.slice(lowRange,topRange)

    var fitnessBefore = []
    var fatigueBefore = []
    var formBefore = []

    var fitnessProj = []
    var fatigueProj = []
    var formProj = []

    for (var i=0;i<dates.length;i++){
        if (i<pointZeroIndex){
            fitnessProj[i]=null
            fatigueProj[i]=null
            formProj[i]=null
            fitnessBefore[i]=fitness[i]
            fatigueBefore[i]=fatigue[i]
            formBefore[i]=form[i]
        }
        else if (i === pointZeroIndex){
                fitnessBefore[i]=fitness[i]
                fatigueBefore[i]=fatigue[i]
                formBefore[i]=form[i]
                fitnessProj[i]=fitness[i]
                fatigueProj[i]=fatigue[i]
                formProj[i]=form[i]
        }
        else{
            fitnessBefore[i]=null
            fatigueBefore[i]=null
            formBefore[i]=null
            fitnessProj[i]=fitness[i]
            fatigueProj[i]=fatigue[i]
            formProj[i]=form[i]
        }
    }
    //console.log(dates,fitnessBefore,fitnessProj)
    return (
        {
            labels:dates,
            datasets: [
              {
                label: "fitness",
                borderColor: "rgba(100, 100, 140, 0.8)",
                pointBorderColor: "rgba(100, 100, 140, 0.8)",
                pointBackgroundColor: "rgba(100, 100, 140, 0.8)",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 0,
                pointHoverRadius: 3,
                pointHoverBorderWidth: 1,
                pointRadius: 0,
                fill: true,
                backgroundColor: 'rgba(100, 100, 100, 0.3)',
                borderWidth: 1,
                data: fitnessBefore,
              },
              {
                label: "Fatigue",
                borderColor: "rgba(140, 140, 100, 0.9)",
                pointBorderColor: 'rgba(140, 140, 100, 0.9)',
                pointBackgroundColor: "rgba(140, 140, 100, 0.9)",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: 'rgba(140, 140, 100, 0.9)',
                pointBorderWidth: 1,
                pointHoverRadius: 7,
                pointHoverBorderWidth: 2,
                pointRadius: 0,
                fill: true,
                backgroundColor: gradientFill,
                borderWidth: 1,
                data: fatigueBefore,
              },
              {
                label: "Form",
                borderColor: "rgba(140, 100, 100, 0.9)",
                pointBorderColor: "rgba(140, 100, 100, 0.9)",
                pointBackgroundColor: "rgba(140, 100, 100, 0.9)",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: "rgba(140, 100, 100, 0.9)",
                pointBorderWidth: 1,
                pointHoverRadius: 7,
                pointHoverBorderWidth: 2,
                pointRadius: 0,
                fill: true,
                backgroundColor: "rgba(140, 100, 100, 0.3)",
                borderWidth: 1,
                data: formBefore,
              },
              {
                label: "fitness projection",
                borderColor: "1ebfe8",
                pointBorderColor: "1ebfe8",
                pointBackgroundColor: "rgba(100, 100, 255, 0.8)",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 0,
                pointHoverRadius: 3,
                pointHoverBorderWidth: 1,
                pointRadius: 0,
                fill: true,
                backgroundColor: 'rgba(100, 100, 200, 0.3)',
                borderWidth: 1,
                data: fitnessProj,
              },
              {
                label: "Fatigue projection",
                borderColor: "#FCBF44",
                pointBorderColor: chartColor,
                pointBackgroundColor: "rgba(255, 255, 100, 0.9)",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 1,
                pointHoverRadius: 7,
                pointHoverBorderWidth: 2,
                pointRadius: 0,
                fill: true,
                backgroundColor: gradientFill,
                borderWidth: 1,
                data: fatigueProj,
              },
              {
                label: "Form projection",
                borderColor: "#E63950",
                pointBorderColor: chartColor,
                pointBackgroundColor: "rgba(255, 100, 100, 0.9)",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 1,
                pointHoverRadius: 7,
                pointHoverBorderWidth: 2,
                pointRadius: 0,
                fill: true,
                backgroundColor: 'rgba(255, 100, 100, 0.1)',
                borderWidth: 1,
                data: formProj,
              },
            ]
        }
    )
}


export const dataTrainingLoadProjectionPlan = (dates,fitness,fatigue,form,chartColor,gradientFill,range,pointZero) =>{
    const topRange = parseInt(range[1] * dates.length/100)
    const lowRange = parseInt(range[0] * dates.length/100)
    dates = dates.slice(lowRange,topRange)

    var pointZeroIndex = 0

    for (var i=0;i<dates.length;i++){
        if (moment(dates[i]).isAfter(moment(pointZero))){
            pointZeroIndex = i-1
            break
        }

        
    }
    fitness = fitness.slice(lowRange,topRange)
    fatigue = fatigue.slice(lowRange,topRange)
    form = form.slice(lowRange,topRange)

    var fitnessBefore = []
    var fatigueBefore = []
    var formBefore = []

    var fitnessProj = []
    var fatigueProj = []
    var formProj = []
    //console.log(dates.length)
    for (var i=0;i<dates.length;i++){
        if (fitness[i] === undefined){
            fitness[i] = fitness[i-1]
          }
        if (fatigue[i] === undefined){
            fatigue[i] = fatigue[i-1]
          }
          if (form[i] === undefined){
            form[i] = form[i-1]
          }
        if (i<pointZeroIndex){
            fitnessProj[i]=null
            fatigueProj[i]=null
            formProj[i]=null
            fitnessBefore[i]=fitness[i]
            fatigueBefore[i]=fatigue[i]
            formBefore[i]=form[i]
        }
        else if (i === pointZeroIndex){
                fitnessBefore[i]=fitness[i]
                fatigueBefore[i]=fatigue[i]
                formBefore[i]=form[i]
                fitnessProj[i]=fitness[i]
                fatigueProj[i]=fatigue[i]
                formProj[i]=form[i]
        }
        else{
            fitnessBefore[i]=null
            fatigueBefore[i]=null
            formBefore[i]=null
            fitnessProj[i]=fitness[i]
            fatigueProj[i]=fatigue[i]
            formProj[i]=form[i]
        }
    }
    //console.log(dates,fitnessBefore,fitnessProj)
    return (
        {
            labels:dates,
            datasets: [
              {
                label: "fitness",
                borderColor: "rgba(100, 100, 140, 0.8)",
                pointBorderColor: "rgba(100, 100, 140, 0.8)",
                pointBackgroundColor: "rgba(100, 100, 140, 0.8)",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 0,
                pointHoverRadius: 3,
                pointHoverBorderWidth: 1,
                pointRadius: 0,
                fill: true,
                backgroundColor: 'rgba(100, 100, 100, 0.3)',
                borderWidth: 1,
                data: fitnessBefore,
              },
              {
                label: "Fatigue",
                borderColor: "rgba(140, 140, 100, 0.9)",
                pointBorderColor: 'rgba(140, 140, 100, 0.9)',
                pointBackgroundColor: "rgba(140, 140, 100, 0.9)",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: 'rgba(140, 140, 100, 0.9)',
                pointBorderWidth: 1,
                pointHoverRadius: 7,
                pointHoverBorderWidth: 2,
                pointRadius: 0,
                fill: true,
                backgroundColor: gradientFill,
                borderWidth: 1,
                data: fatigueBefore,
              },
              {
                label: "Form",
                borderColor: "rgba(140, 100, 100, 0.9)",
                pointBorderColor: "rgba(140, 100, 100, 0.9)",
                pointBackgroundColor: "rgba(140, 100, 100, 0.9)",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: "rgba(140, 100, 100, 0.9)",
                pointBorderWidth: 1,
                pointHoverRadius: 7,
                pointHoverBorderWidth: 2,
                pointRadius: 0,
                fill: true,
                backgroundColor: "rgba(140, 100, 100, 0.3)",
                borderWidth: 1,
                data: formBefore,
              },
              {
                label: "fitness projection",
                borderColor: "1ebfe8",
                pointBorderColor: "1ebfe8",
                pointBackgroundColor: "rgba(100, 100, 255, 0.8)",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 0,
                pointHoverRadius: 3,
                pointHoverBorderWidth: 1,
                pointRadius: 0,
                fill: true,
                backgroundColor: 'rgba(100, 100, 200, 0.3)',
                borderWidth: 1,
                data: fitnessProj,
              },
              {
                label: "Fatigue projection",
                borderColor: "#FCBF44",
                pointBorderColor: chartColor,
                pointBackgroundColor: "rgba(255, 255, 100, 0.9)",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 1,
                pointHoverRadius: 7,
                pointHoverBorderWidth: 2,
                pointRadius: 0,
                fill: true,
                backgroundColor: gradientFill,
                borderWidth: 1,
                data: fatigueProj,
              },
              {
                label: "Form projection",
                borderColor: "#E63950",
                pointBorderColor: chartColor,
                pointBackgroundColor: "rgba(255, 100, 100, 0.9)",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 1,
                pointHoverRadius: 7,
                pointHoverBorderWidth: 2,
                pointRadius: 0,
                fill: true,
                backgroundColor: 'rgba(255, 100, 100, 0.1)',
                borderWidth: 1,
                data: formProj,
              },
            ]
        }
    )
}
export const optionsTrainingLoad = () =>{
    
    return (
        {
        layout: {
            padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0,
            },
        },
        maintainAspectRatio: false,
        tooltips: {
            backgroundColor: "#fff",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
        },
        legend: {
            position: "bottom",
            fillStyle: "#FFF",
            display: false,
        },
        scales: {
            yAxes: [
            {
                ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,
                
                },
                gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent",
                },
            },
            ],
            xAxes: [
            {
                gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)",
                },
                ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                },
                type:'time',
                distribution: 'series',
                time: {
                displayFormats: {
                parser: 'YYYY/MM/DD',
                unit: 'day',
                unitStepSize: 1,
                
                quarter: 'MMM YYYY'
                }
                }
            },
            ],
        },
        plugins:{
            zoom:{
                pan:{
                    enabled:false,
                    mode:'x'
                },
                zoom:{
                    enabled:false,
                    drag:false,
                    mode:'x'
                }
            }
        }
        
        }
    )
}



////  Weekly milage graph

export const dataWeeklyMileage = (dates,distance,chartColor,gradientFill,range,metric,value) =>{
    

    if (value === "Distance"){
        const topRange = parseInt(range[1] * dates.length/100)
        const lowRange = parseInt(range[0] * dates.length/100)
        dates = dates.slice(lowRange,topRange)
        distance = distance.slice(lowRange,topRange)
        distance = distance.map(item => (item/1000).toFixed(1))
    }
    if (value === "Duration"){
        const topRange = parseInt(range[1] * dates.length/100)
        const lowRange = parseInt(range[0] * dates.length/100)
        dates = dates.slice(lowRange,topRange)
        distance = distance.slice(lowRange,topRange)
        distance = distance.map(item => (item/60).toFixed(1))
        metric = "hours"
    }
    

    return (
        {
            labels:dates,
            datasets: [
              {
                label: metric,
                borderColor: "rgba(255, 200, 100, 0.7)",
                pointBorderColor: "rgba(255, 200, 100, 0.7)",
                pointBackgroundColor: "rgba(255, 200, 100, 0.7)",
                pointHoverBackgroundColor: "rgba(255, 200, 100, 0.7)",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 0,
                pointHoverRadius: 3,
                pointHoverBorderWidth: 1,
                pointRadius: 4,
                fill: true,
                backgroundColor: 'rgba(255, 200, 100, 0.9)',
                borderWidth: 1,
                data: distance,
              },
              
            ]
        }
    )
}


export const optionsWeeklyMileage = (max) =>{
    
    return (
        {
        layout: {
            padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0,
            },
        },
        maintainAspectRatio: false,
        tooltips: {
            backgroundColor: "#fff",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
        },
        legend: {
            position: "bottom",
            fillStyle: "#FFF",
            display: false,
        },
        scales: {
            yAxes: [
            {
                ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,
                
                min:0,
                },
                gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent",
                },
            },
            ],
            xAxes: [
            {
                gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)",
                },
                ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                },
                type:'time',
                distribution: 'series',
                time: {
                displayFormats: {
                parser: 'YYYY/MM/DD',
                unit: 'week',
                unitStepSize: 1,
                
                quarter: 'MMM YYYY'
                }
                }
            },
            ],
        },
        plugins:{
            zoom:{
                pan:{
                    enabled:false,
                    mode:'x'
                },
                zoom:{
                    enabled:false,
                    drag:false,
                    mode:'x'
                }
            }
        }
        
        }
    )
}



export const dataWeeklyMileageRoll = (dates,distance,chartColor,gradientFill,range,metric,value) =>{
    var color
    var backColor
    const topRange = parseInt(range[1] * dates.length/100)
    const lowRange = parseInt(range[0] * dates.length/100)
    dates = dates.slice(lowRange,topRange)
    distance = distance.slice(lowRange,topRange)
    if (value =='Distance'){
        distance = distance.map(item => item/1000)
        backColor = 'rgba(100, 200, 250, 0.4)'
        color = 'rgba(100, 200, 250, 0.4)'
    }
    if (value =='Duration'){
        distance = distance.map(item => item/60)
        metric = 'hours'
        backColor = 'rgba(255, 100, 100, 0.2)'
        color = "rgb(255,100,100)"
    }
    

    return (
        {
            labels:dates,
            datasets: [
              {
                label: metric,
                borderColor: color,
                pointBorderColor: color,
                pointBackgroundColor: "#2c2c2c",
                pointHoverBackgroundColor: "#2c2c2c",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 1,
                pointHoverRadius: 3,
                pointHoverBorderWidth: 1,
                pointRadius: 1,
                fill: true,
                backgroundColor: backColor,
                borderWidth: 1,
                data: distance,
              },
              
            ]
        }
    )
}




export const dataProgram = (data) =>{
    
    const base =      [data[0],null,null,null,null,null]
    const long =      [null,data[1],null,null,null,null]
    const aerobic1 =  [null,null,data[2],null,null,null]
    const aerobic2 =  [null,null,null,data[3],null,null]
    const tempo =     [null,null,null,null,data[4],null]
    const max =       [null,null,null,null,null,data[5]]
    return (
        {
            labels:["Base","Long","Aerobic I","Aerobic II","Tempo","Maximum"],
            datasets: [
              {
                label:'Base',
                borderColor: "rgba(100, 100, 250, 0.7)",
                pointBorderColor: "rgba(100, 100, 250, 0.7)",
                pointBackgroundColor: "rgba(100, 100, 250, 0.7)",
                pointHoverBackgroundColor: "rgba(100, 100, 250, 0.7)",
                pointHoverBorderColor: "rgba(100, 100, 250, 0.7)",
                pointBorderWidth: 0,
                pointHoverRadius: 3,
                pointHoverBorderWidth: 1,
                pointRadius: 4,
                fill: true,
                backgroundColor: "rgba(100, 100, 250, 0.7)",
                borderWidth: 1,
                data: base,
              },
              {
                label:'Long',
                borderColor: "rgba(100, 160, 240, 0.7)",
                pointBorderColor: "rgba(100, 160, 240, 0.7)",
                pointBackgroundColor: "rgba(100, 160, 240, 0.7)",
                pointHoverBackgroundColor: "rgba(100, 160, 240, 0.7)",
                pointHoverBorderColor: "rgba(100, 160, 240, 0.7)",
                pointBorderWidth: 0,
                pointHoverRadius: 3,
                pointHoverBorderWidth: 1,
                pointRadius: 4,
                fill: true,
                backgroundColor: "rgba(100, 160, 240, 0.7)",
                borderWidth: 1,
                data: long,
              },
              {
                label:'Aerobic I',
                borderColor: "rgba(100, 230, 150, 0.7)",
                pointBorderColor: "rgba(100, 230, 150, 0.7)",
                pointBackgroundColor: "rgba(100, 230, 150, 0.7)",
                pointHoverBackgroundColor: "rgba(100, 230, 150, 0.7)",
                pointHoverBorderColor: "rgba(100, 230, 150, 0.7)",
                pointBorderWidth: 0,
                pointHoverRadius: 3,
                pointHoverBorderWidth: 1,
                pointRadius: 4,
                fill: true,
                backgroundColor: 'rgba(100, 230, 150, 0.7)',
                borderWidth: 1,
                data: aerobic1,
              },
              {
                label:'Aerobic II',
                borderColor: "rgba(130, 255, 100, 0.7)",
                pointBorderColor: "rgba(130, 255, 100, 0.7)",
                pointBackgroundColor: "rgba(130, 255, 100, 0.7)",
                pointHoverBackgroundColor: "rgba(130, 255, 100, 0.7)",
                pointHoverBorderColor: "rgba(130, 255, 100, 0.7)",
                pointBorderWidth: 0,
                pointHoverRadius: 3,
                pointHoverBorderWidth: 1,
                pointRadius: 4,
                fill: true,
                backgroundColor: "rgba(130, 255, 100, 0.7)",
                borderWidth: 1,
                data: aerobic2,
              },
              {
                label:'Threshold',
                borderColor: "rgba(255, 200, 100, 0.7)",
                pointBorderColor: "rgba(255, 200, 100, 0.7)",
                pointBackgroundColor: "rgba(255, 200, 100, 0.7)",
                pointHoverBackgroundColor: "rgba(255, 200, 100, 0.7)",
                pointHoverBorderColor: "rgba(255, 200, 100, 0.7)",
                pointBorderWidth: 0,
                pointHoverRadius: 3,
                pointHoverBorderWidth: 1,
                pointRadius: 4,
                fill: true,
                backgroundColor: 'rgba(255, 200, 100, 0.9)',
                borderWidth: 1,
                data: tempo,
              },
              {
                label:'Maximum',
                borderColor: "rgba(255, 100, 100, 0.7)",
                pointBorderColor: "rgba(255, 100, 100, 0.7)",
                pointBackgroundColor: "rgba(255, 100, 100, 0.7)",
                pointHoverBackgroundColor: "rgba(255, 100, 100, 0.7)",
                pointHoverBorderColor: "rgba(255, 100, 100, 0.7)",
                pointBorderWidth: 0,
                pointHoverRadius: 3,
                pointHoverBorderWidth: 1,
                pointRadius: 4,
                fill: true,
                backgroundColor: 'rgba(255, 100, 100, 0.9)',
                borderWidth: 1,
                data: max,
              },
            ]
        }
    )
}



export const optionProgram = () =>{
    
    return (
        {
        layout: {
            padding: {
            left: 3,
            right: 3,
            top: 0,
            bottom: 0,
            },
        },
        maintainAspectRatio: false,
        tooltips: {
            backgroundColor: "#fff",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 1,
            xPadding: 1,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
        },
        legend: {
            position: "bottom",
            fillStyle: "#FFF",
            display: false,
        },
        scales: {
            yAxes: [
            {
                ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 2,
                
                min:0,
                },
                gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent",
                },
            },
            ],
            xAxes: [
            {
                categoryPercentage: 1.0,
                barPercentage: 1.0,
            
            },
            ],
        },
        plugins:{
            zoom:{
                pan:{
                    enabled:false,
                    mode:'x'
                },
                zoom:{
                    enabled:false,
                    drag:false,
                    mode:'x'
                }
            }
        }
        
        }
    )
}



export const dataPerfResample = (dates,index,chartColor,gradientFill) =>{
    
    

    return (
        {
            labels:dates,
            datasets: [
              {
                label: 'average Index',
                borderColor: "rgba(255, 255, 255, 0.8)",
                pointBorderColor: "rgba(100, 180, 255, 0.9)",
                pointBackgroundColor: "rgba(100, 230, 255, 1)",
                pointHoverBackgroundColor: "rgba(255, 200, 100, 1)",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 2,
                pointHoverRadius: 12,
                pointHoverBorderWidth: 1,
                pointRadius: 4,
                fill: true,
                backgroundColor: "rgba(255, 255, 255, 0.15)",
                borderWidth: 2,
                data: index,
              },
              
            ]
        }
    )
}


export const optionsPerfResample = (max) =>{
    
    return (
        {
        layout: {
            padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0,
            },
        },
        maintainAspectRatio: false,
        tooltips: {
            backgroundColor: "#fff",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
        },
        legend: {
            position: "bottom",
            fillStyle: "#FFF",
            display: false,
        },
        scales: {
            yAxes: [
            {
                ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,
                min:20,
                },
                gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent",
                },
            },
            ],
            xAxes: [
            {
                gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)",
                },
                ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                },
                type:'time',
                distribution: 'linear',
                time: {
                displayFormats: {
                parser: 'YYYY/MM/DD',
                unit: 'week',
                unitStepSize: 1,
                
                quarter: 'MMM YYYY'
                }
                }
            },
            ],
        },
        plugins:{
            zoom:{
                pan:{
                    enabled:false,
                    mode:'x'
                },
                zoom:{
                    enabled:false,
                    drag:false,
                    mode:'x'
                }
            }
        }
        
        }
    )
}


export const dataDonut = (labels,dataset) =>{
    
    var chartColor = []
    for (var i=0;i<labels.length;i++){
        if (labels[i] == 'Interval'){
            chartColor.push('rgb(200,100,30)')
        }
        else if (labels[i] == 'Aerobic I'){
            chartColor.push('rgb(100,200,150)')
        }
        else if (labels[i] == 'Aerobic II'){
            chartColor.push('rgb(70,250,100)')
        }
        else if (labels[i] == 'Threshold'){
            chartColor.push('rgb(200,250,70)')
        }
        else if (labels[i] == 'Base'){
            chartColor.push('rgb(100,100,200)')
        }
        else if (labels[i] == 'Ride'){
            chartColor.push('rgb(250,250,250)')
        }
        else if (labels[i] == 'Swim'){
            chartColor.push('rgb(100,150,200)')
        }
        else if (labels[i] == 'WeightTraining'){
            chartColor.push('rgb(200,50,30)')
        }
        else if (labels[i] == 'Walk'){
            chartColor.push('rgb(100,180,250)')
        }
        else{
            chartColor.push('rgb(100,50,250)')
        }
    }
    console.log(chartColor)
    return (
        {
            labels:labels,
            datasets: [
              {
                label: "Index raw",
                backgroundColor: chartColor,
                pointBorderWidth: 1,
                pointHoverRadius: 2,
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                fill: false,
                
                borderWidth: 2,
                data: dataset,
                showLine:false,
              },
              
            ]
        }
    )
}
